import { Injectable } from "@angular/core";
import { ContractsService } from "app/services/contract/contracts.service";
import { SpinnerService } from "app/services/spinner/spinner.service";
import { BehaviorSubject, Observable, Observer, ReplaySubject, from, switchMap } from "rxjs";
import { eProviders, eStatus, iStatus, Web3Service } from "../../web3/web3.service";
import { MetamaskWrapperService, getProviderOption } from "./metamask-wrapper.service";
import Web3 from 'web3';
import { getPublicClient, getWalletClient, getAccount, watchPublicClient, connect, InjectedConnector } from '@wagmi/core'
import { useAccount, usePublicClient, useWalletClient } from "wagmi";
import WalletConnectProvider, { EthereumProvider } from '@walletconnect/ethereum-provider';
@Injectable({
    providedIn: 'root'
})

export class MetamaskService {

    loggedSuccessfully: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
    loggedStatus: BehaviorSubject<iStatus> = new BehaviorSubject<iStatus>({ status: eStatus.notinit, value: null });

    constructor(
        private web3Service: Web3Service,
        private spinnerService: SpinnerService,
        private contractsService: ContractsService,
        private metamaskWrapperService: MetamaskWrapperService
    ) { }

    login(isWalletMissing: boolean/* , callback: () => void */) {
        let that = this;
        const account = getAccount();
        if (account.isConnected) this.mountWallet();
        else {
            this.metamaskWrapperService.connect().subscribe({
                next(modal) {
                    console.log('modal', modal);
                    modal.subscribeEvents(
                        (event: { name: string; }) => {
                            if (event.name === 'ACCOUNT_CONNECTED') {
                                that.setLocalLoginMode();//Mandatory
                                that.mountWallet();
                            }
                        }
                    )

                },
                error(err) {
                    console.log('User reject', err);
                },
            });
        }
    }

    // setWeb3(): boolean {
    //     // let web3 = this.magicWrapperService.getWeb3Magic();
    //     // if (web3) this.web3Service.setWeb3(web3);
    //     // return web3?.eth ? true : false;
    // }

    //mountWallet is used when user is already logged and cookies are not expired
    //eg. refresh page
    // mountWallet(): void {
    //     const account = getAccount();
    //     console.log('account mount wallet', account);

    //     let loginMode: string = localStorage.getItem('loginMode');


    //     if (loginMode === 'browserExt') {
    //         from(connect({
    //             connector: new InjectedConnector(),
    //         })).subscribe(result => {

    //             let provider = result.connector.options.getProvider();
    //             this.setProviderAndLogin(provider, false);

    //         });
    //     } else {
    //         //QRcode
    //         let _provider;
    //         from(EthereumProvider.init(getProviderOption())).pipe(switchMap(
    //             provider => {
    //                 _provider = provider;
    //                 return from(provider.enable());
    //             }
    //         )).subscribe(
    //             _ => {
    //                 this.setProviderAndLogin(_provider, false);
    //             }
    //         )
    //     }
    // }

    mountWallet() {
        let loginMode: string = localStorage.getItem('loginMode');
        this.provider$().subscribe(
            provider => {
                if (loginMode === 'browserExt') {
                    this.setProviderAndLogin(provider, false);
                } else {
                    from(provider.enable()).subscribe(
                        _ => {
                            this.setProviderAndLogin(provider, false);
                        }
                    )
                }
            }
        )
    }

    setLocalLoginMode() {
        //TO USE ONLY DURING LOGIN
        const account = getAccount();
        let provider;
        try {
            provider = account.connector.options?.getProvider();
            localStorage.setItem('loginMode', 'browserExt');
        } catch (error) {
            localStorage.setItem('loginMode', 'QRcode');
            provider = null;
        }
    }
    provider$(): Observable<any> {
        let loginMode: string = localStorage.getItem('loginMode');
        const account = getAccount();
        if (loginMode === 'browserExt') {
            if (account.connector) {
                //in case of login with extension (browserExt) getProvider() should be present
                return new Observable((observer: Observer<any>) => {
                    observer.next(account.connector.options.getProvider())
                    observer.complete();
                })
            } else {
                //if wallet is already selected but it is necessary to inject a new connector
                //eg. during refresh page
                return from(connect({
                    connector: new InjectedConnector(),
                })).pipe(switchMap(
                    result => {
                        let provider = result.connector.options.getProvider();
                        return new Observable((observer: Observer<any>) => {
                            observer.next(provider)
                            observer.complete();
                        })
                    }
                ))
            }
        } else {
            //QRcode
            return from(EthereumProvider.init(getProviderOption())).pipe(switchMap(
                provider => {
                    return new Observable((observer: Observer<any>) => {
                        observer.next(provider)
                        observer.complete();
                    })
                }
            )
            )
        }

    }

    setProviderAndLogin(provider, isWalletMissing) {
        this.web3Service.setWeb3(new Web3(provider));
        this.web3Service.getChainId().subscribe(netId => {
            this.web3Service.mountWallet(netId);
            if (!isWalletMissing) {
                this.loggedSuccessfully.next(true);
                this.loggedStatus.next({ status: eStatus.success, value: provider })
                /* callback(); */
            }
            else this.web3Service.linkWalletPlayFab(eProviders.metamask/* , () => callback() */);
        });
    }
}

// const Web3 = require('web3');